import { render, staticRenderFns } from "./LogCRUD.vue?vue&type=template&id=f70ceff2&scoped=true&"
import script from "./LogCRUD.vue?vue&type=script&lang=js&"
export * from "./LogCRUD.vue?vue&type=script&lang=js&"
import style0 from "./LogCRUD.vue?vue&type=style&index=0&id=f70ceff2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70ceff2",
  null
  
)

export default component.exports